import * as types from './ActionTypes';
export * from './coursesActions';
export * from './trailsActions';
export * from './calendarActions';
export * from './segmentActions';
export * from './badgesActions';
export * from './groupActions';
export * from './groupPageActions';
export * from './activitiesActions';
export * from './adaptiveTrainingPlanActions';
export * from './userPreferenceActions';
export * from './statsActions';
export * from './exercisesActions';
export * from './mfpActions';
export * from './paceProBandActions';
export * from './golfCourseActions';
export * from './workoutTypesActions';
export * from './workoutsActions';
export * from './workoutActions';
export * from './healthSnapshotActions';
export * from './conversationLikesActions';
export * from './ecgRecordingActions';
export * from './usageIndicatorsActions';
export * from './jetLagActions';
export * from './challengePageActions';
export * from './pushesActions';
export * from './bodyBatteryActions';
export * from './sleepReportActions';
export * from './sleepActions';
export * from './socialActions';
export * from './socialGroupRideActions';
export * from './eventsActions';

/**
 * PUBLIC USER PROFILE
 */
export const requestPublicUserProfile = (displayName) => ({
    type: types.REQUEST_PUBLIC_USER_PROFILE,
    displayName
});

export const receivePublicUserProfile = (displayName, json) => ({
    type: types.RECEIVE_PUBLIC_USER_PROFILE,
    displayName,
    publicUserProfile: json,
    receivedAt: Date.now()
});

export const failedPublicUserProfile = (displayName) => ({
    type: types.FAILED_PUBLIC_USER_PROFILE,
    displayName,
    publicUserProfile: null,
    receivedAt: Date.now()
});

export const setShowProfilePageGeneralError = (show = false) => {
    return {
        type: types.SET_SHOW_PROFILE_PAGE_GENERAL_ERROR,
        show
    };
};

export const resetPublicUserProfile = () => {
    return { type: types.RESET_PUBLIC_USER_PROFILE };
};

export const fetchPublicUserProfile = (displayName) => ({
    type: types.FETCH_PUBLIC_USER_PROFILE,
    displayName
});
// END PUBLIC USER PROFILE

export const requestDailySummary = (userId, date) => ({
    type: types.REQUEST_DAILY_SUMMARY,
    userId,
    date
});

export const receiveDailySummary = (userId, json) => ({
    type: types.RECEIVE_DAILY_SUMMARY,
    userId,
    dailySummary: json,
    receivedAt: Date.now()
});

export const fetchDailySummary = (userId, date) => ({
    type: types.FETCH_DAILY_SUMMARY,
    userId,
    date
});

export const setMatSupportFilter = (filter) => ({
    type: types.SET_MAT_SUPPORT_FILTER,
    filter
});

export const setMatSupportExpandedDevice = (expandedDevice) => ({
    type: types.SET_MAT_SUPPORT_EXPANDED_DEVICE,
    expandedDevice
});

export const setMatSupportReportFilter = (filter) => ({
    type: types.SET_MAT_SUPPORT_REPORT_FILTER,
    filter
});

export const requestRegisteredDevices = (displayName) => ({
    type: types.REQUEST_REGISTERED_DEVICES,
    displayName
});

export const receiveRegisteredDevices = (displayName, json) => ({
    type: types.RECEIVE_REGISTERED_DEVICES,
    displayName,
    registeredDevices: json,
    receivedAt: Date.now()
});

export const fetchRegisteredDevices = (displayName) => ({
    type: types.FETCH_REGISTERED_DEVICES,
    displayName
});

export const requestValidateDailySummary = (userId) => ({
    type: types.REQUEST_VALIDATE_DAILY_SUMMARY,
    userId
});

export const receiveValidateDailySummary = (userId, date, json) => ({
    type: types.RECEIVE_VALIDATE_DAILY_SUMMARY,
    userId,
    date,
    validateDailySummary: json,
    receivedAt: Date.now()
});

export const fetchValidateDailySummary = (userId, date) => ({
    type: types.FETCH_VALIDATE_DAILY_SUMMARY,
    userId,
    date
});

export const requestValidateDeviceEpoch = (userId, date, deviceId) => ({
    type: types.REQUEST_VALIDATE_DEVICE_EPOCH,
    userId,
    date,
    deviceId
});

export const receiveValidateDeviceEpoch = (userId, date, deviceId, json) => ({
    type: types.RECEIVE_VALIDATE_DEVICE_EPOCH,
    userId,
    date,
    deviceId,
    validateDeviceEpoch: json,
    receivedAt: Date.now()
});

export const fetchValidateDeviceEpoch = (userId, date, deviceId) => ({
    type: types.FETCH_VALIDATE_DEVICE_EPOCH,
    userId,
    date,
    deviceId
});

export const requestValidateDeviceEpochSummary = (userId, date) => ({
    type: types.REQUEST_VALIDATE_DEVICE_EPOCH_SUMMARY,
    userId,
    date
});

export const receiveValidateDeviceEpochSummary = (userId, date, json) => ({
    type: types.RECEIVE_VALIDATE_DEVICE_EPOCH_SUMMARY,
    userId,
    date,
    validateDeviceEpochSummary: json,
    receivedAt: Date.now()
});

export const fetchValidateDeviceEpochSummary = (userId, date) => ({
    type: types.FETCH_VALIDATE_DEVICE_EPOCH_SUMMARY,
    userId,
    date
});

export const requestValidateDeviceHeartRate = (userId, date, deviceId) => ({
    type: types.REQUEST_VALIDATE_DEVICE_HEART_RATE,
    userId,
    date,
    deviceId
});

export const receiveValidateDeviceHeartRate = (userId, date, deviceId, json) => ({
    type: types.RECEIVE_VALIDATE_DEVICE_HEART_RATE,
    userId,
    date,
    deviceId,
    validateDeviceHeartRate: json,
    receivedAt: Date.now()
});

export const fetchValidateDeviceHeartRate = (userId, date, deviceId) => ({
    type: types.FETCH_VALIDATE_DEVICE_HEART_RATE,
    userId,
    date,
    deviceId
});

export const requestValidateDeviceHeartRateSummary = (userId, date) => ({
    type: types.REQUEST_VALIDATE_DEVICE_HEART_RATE_SUMMARY,
    userId,
    date
});

export const receiveValidateDeviceHeartRateSummary = (userId, date, json) => ({
    type: types.RECEIVE_VALIDATE_DEVICE_HEART_RATE_SUMMARY,
    userId,
    date,
    validateDeviceHeartRateSummary: json,
    receivedAt: Date.now()
});

export const fetchValidateDeviceHeartRateSummary = (userId, date) => ({
    type: types.FETCH_VALIDATE_DEVICE_HEART_RATE_SUMMARY,
    userId,
    date
});

/**
 * USER PRIVACY
 */
export const requestUserPrivacy = (displayName) => {
    return {
        type: types.REQUEST_USER_PRIVACY,
        displayName
    };
};

export const receiveUserPrivacy = (displayName, json) => {
    return {
        type: types.RECEIVE_USER_PRIVACY,
        displayName,
        userPrivacy: json,
        receivedAt: Date.now()
    };
};

export const failedUserPrivacy = (displayName) => {
    return {
        type: types.FAILED_USER_PRIVACY,
        displayName,
        userPrivacy: null,
        receivedAt: Date.now()
    };
};

export const updatePrivacy = (displayName, data) => {
    return {
        type: types.UPDATE_USER_PRIVACY,
        displayName,
        userPrivacy: data
    };
};

export const fetchUserPrivacy = (url, displayName) => ({
    type: types.FETCH_PROFILE_USER_PRIVACY,
    displayName
});

export const updateUserPrivacy = (displayName, data, privacy) => ({
    type: types.UPDATE_USER_SOCIAL_PRIVACY,
    displayName,
    data,
    privacy
});
// END USER PRIVACY

/**
 SYSTEM MESSAGES
 */
export const fetchSystemMessage = () => ({
    type: types.FETCH_SYSTEM_MESSAGE
});

export const receiveSystemMessage = (json) => {
    return {
        type: types.RECEIVE_SYSTEM_MESSAGE,
        systemMessage: json,
        receivedAt: Date.now()
    };
};

export const fetchSystemPreferenceSaga = (key) => ({
    type: types.RECEIVE_SYSTEM_PREFERENCE,
    key: key
});

export const fetchSystemStatus = () => ({
    type: types.FETCH_SYSTEM_STATUS
});

export const receiveSystemStatus = (json) => {
    return {
        type: types.RECEIVE_SYSTEM_STATUS,
        systemStatus: json,
        receivedAt: Date.now()
    };
};

// END SYSTEM MESSAGES

/**
 * PAGE MESSAGES
 */
export const setPageMessage = (messageType, messageText, messageView) => {
    return {
        type: types.SET_PAGE_MESSAGE,
        messageText,
        messageType,
        messageView
    };
};

export const setPageStatus = (status) => {
    return {
        type: types.SET_PAGE_STATUS,
        status
    };
};

export const removePageMessage = () => {
    return {
        type: types.REMOVE_PAGE_MESSAGE
    };
};
// END PAGE MESSAGES

/**
 * USER PROFILE ACTIVITY COMMENTS
 */

export const requestComments = (resourceId) => {
    return {
        type: types.REQUEST_COMMENTS,
        resourceId
    };
};

export const receiveComments = (data, resourceId) => {
    return {
        type: types.RECEIVE_COMMENTS,
        comments: data,
        resourceId: resourceId,
        receivedAt: Date.now()
    };
};

export const failedComments = (resourceId) => {
    return {
        type: types.FAILED_COMMENTS,
        comments: [],
        resourceId: resourceId,
        receivedAt: Date.now()
    };
};

export const resetComments = () => {
    return { type: types.RESET_COMMENTS };
};

export const fetchComments = (resourceType, resourceId, start = 1, limit = 10) => ({
    type: types.FETCH_COMMENTS,
    resourceType,
    resourceId,
    start,
    limit
});

export const commentAdded = (data, resourceId) => {
    return {
        type: types.ADD_COMMENT,
        comment: data,
        resourceId: resourceId,
        addedAt: Date.now()
    };
};

export const addComment = (resourceId, resourceType, data, shouldFetchComments = false) => ({
    type: types.ADD_CONVERSASION_COMMENT,
    resourceId,
    resourceType,
    data,
    shouldFetchComments
});

/**
 *
 * @param {string} resourceId
 * @param {string} resourceType
 * @param {any} data
 * @param {string | boolean} error
 * false = no error; true = generic error; string = specific error
 * @returns
 */
export const addCommentDone = (resourceId, resourceType, data, error = false) => {
    return {
        type: types.ADD_CONVERSASION_COMMENT_DONE,
        resourceId,
        resourceType,
        data,
        error
    };
};

export const commentDeleted = (data, resourceId) => {
    return {
        type: types.REMOVE_COMMENT,
        conversationCommentUuid: data.conversationCommentUuid,
        resourceId: resourceId
    };
};

export const deleteComment = (resourceType, resourceId, data) => ({
    type: types.DELETE_COMMENT,
    resourceType,
    resourceId,
    data
});

export const requestCommentLikes = () => {
    return {
        type: types.REQUEST_COMMENT_LIKES
    };
};

export const receiveCommentLikes = (data, conversationCommentUuid) => {
    return {
        type: types.RECEIVE_COMMENT_LIKES,
        data: data,
        conversationCommentUuid: conversationCommentUuid,
        receivedAt: Date.now()
    };
};

export const resetCommentLikes = () => {
    return {
        type: types.RESET_COMMENT_LIKES
    };
};

export const fetchCommentLikes = (conversationCommentUuid) => ({
    type: types.FETCH_COMMENT_LIKES,
    conversationCommentUuid
});

export const editComment = (data, resourceId) => {
    return {
        type: types.EDIT_COMMENT_START,
        comment: data,
        resourceId: resourceId
    };
};

export const commentEditDone = (data, resourceId) => {
    return {
        type: types.EDIT_COMMENT_DONE,
        comment: data,
        resourceId: resourceId
    };
};

export const commentEditError = (data, resourceId, error) => {
    return {
        type: types.EDIT_COMMENT_ERROR,
        comment: data,
        resourceId: resourceId,
        error
    };
};

//END USER PROFILE ACTIVITY COMMENTS

/**
 * USER PROFILE ACTIVITY CONVERSATION
 */

export const requestConversation = () => {
    return {
        type: types.REQUEST_CONVERSATION
    };
};

export const receiveConversation = (data, resourceId) => {
    return {
        type: types.RECEIVE_CONVERSATION,
        conversation: data,
        resourceId: resourceId,
        receivedAt: Date.now()
    };
};

export const manageComments = (resourceId, add) => {
    return {
        type: types.MANAGE_COMMENTS,
        add,
        resourceId
    };
};

export const resetConversation = () => {
    return { type: types.RESET_CONVERSATION };
};

export const fetchConversation = (resourceType, resourceId) => ({
    type: types.FETCH_CONVERSATION,
    resourceType,
    resourceId
});

export const postConversation = (resourceType, resourceId, data) => ({
    type: types.POST_CONVERSATION,
    resourceType,
    resourceId,
    data
});

const requestConversationLikes = () => {
    return { type: types.REQUEST_CONVERSATION_LIKES };
};

const receiveConversationLikes = (data, resourceId) => {
    return {
        type: types.RECEIVE_CONVERSATION_LIKES,
        resourceId,
        data,
        receivedAt: Date.now()
    };
};

export const resetConversationLikes = () => {
    return { type: types.RESET_CONVERSATION_LIKES };
};

export const fetchGroupConversation = (userGroupPk, resourceType, resourceId) => ({
    type: types.FETCH_GROUP_CONVERSATION,
    userGroupPk,
    resourceType,
    resourceId
});

export const postGroupConversation = (userGroupPk, resourceType, resourceId, data) => ({
    type: types.POST_GROUP_CONVERSATION,
    userGroupPk,
    resourceType,
    resourceId,
    data
});

export const receiveGroupConversation = (data, resourceId) => {
    return {
        type: types.RECEIVE_GROUP_CONVERSATION,
        conversation: data,
        resourceId: resourceId,
        receivedAt: Date.now()
    };
};

export const requestGroupConversation = () => {
    return {
        type: types.REQUEST_GROUP_CONVERSATION
    };
};

const receiveGroupConversationLikes = (data, resourceId) => {
    return {
        type: types.RECEIVE_GROUP_CONVERSATION_LIKES,
        resourceId,
        data,
        receivedAt: Date.now()
    };
};

const requestGroupConversationLikes = () => {
    return { type: types.REQUEST_GROUP_CONVERSATION_LIKES };
};

//END USER PROFILE ACTIVITY CONVERSATION

/**
 * LIKE
 */
export const manageCommentLikes = (resourceId, conversationCommentUuid, add) => ({
    type: types.MANAGE_COMMENT_LIKES,
    conversationCommentUuid,
    add,
    resourceId
});

export const addCommentLike = (resourceType, resourceId, data) => ({
    type: types.ADD_COMMENT_LIKE,
    resourceType,
    resourceId,
    data
});

export const removeCommentLike = (resourceType, resourceId, conversationCommentUuid) => ({
    type: types.REMOVE_COMMENT_LIKE,
    resourceType,
    resourceId,
    conversationCommentUuid
});

const manageLikes = (resourceId, add) => {
    return {
        type: types.MANAGE_LIKES,
        add,
        resourceId
    };
};

export const addLike = (resourceType, resourceId, conversationUuid) => ({
    type: types.ADD_CONVERSATION_LIKE,
    resourceType,
    resourceId,
    conversationUuid
});

export const removeLike = (resourceType, resourceId, conversationUuid) => ({
    type: types.REMOVE_CONVERSATION_LIKE,
    resourceType,
    resourceId,
    conversationUuid
});

const manageGroupLikes = (resourceId, add) => {
    return {
        type: types.MANAGE_GROUP_LIKES,
        add,
        resourceId
    };
};

export const addGroupLike = (userGroupPk, resourceType, resourceId, conversationUuid) => ({
    type: types.ADD_GROUP_CONVERSATION_LIKE,
    userGroupPk,
    resourceType,
    resourceId,
    conversationUuid
});

export const removeGroupLike = (userGroupPk, resourceType, resourceId, conversationUuid) => ({
    type: types.REMOVE_GROUP_CONVERSATION_LIKE,
    userGroupPk,
    resourceType,
    resourceId,
    conversationUuid
});
//END LIKE

/**
 * CONNECTIONS PROFILE STATUS
 */
export const requestConnectionProfileStatus = (displayName) => ({
    type: types.REQUEST_CONNECTION_PROFILE_STATUS,
    displayName
});
export const receiveConnectionProfileStatus = (displayName, json) => ({
    type: types.RECEIVE_CONNECTION_PROFILE_STATUS,
    displayName,
    userConnections: json,
    receivedAt: Date.now()
});
export const failedConnectionProfileStatus = (displayName) => ({
    type: types.FAILED_CONNECTION_PROFILE_STATUS,
    displayName,
    userConnections: null,
    receivedAt: Date.now()
});

export const resetConnectionProfileStatus = () => {
    return { type: types.RESET_CONNECTION_PROFILE_STATUS };
};

export const fetchConnectionProfileStatus = (displayName) => ({
    type: types.FETCH_CONNECTION_PROFILE_STATUS,
    displayName
});
// END CONNECTIONS PROFILE STATUS

/**
 * BEGIN SEND CONNECTION REQUEST
 **/
export const saveSendConnectionRequest = (displayName, fetchStatus = true, callback) => ({
    type: types.SAVE_SEND_CONNECTION_REQUEST,
    displayName,
    fetchStatus,
    callback
});
// END SEND CONNECTION REQUEST

/**
 * BEGIN PENDING CONNECTION REQUEST
 **/
export const receivePendingConnections = (json) => ({
    type: types.RECEIVE_PENDING_CONNECTIONS,
    json,
    receivedAt: Date.now()
});

export const requestPendingConnections = () => {
    return {
        type: types.REQUEST_PENDING_CONNECTIONS
    };
};

export const resetPendingConnections = () => {
    return { type: types.RESET_PENDING_CONNECTIONS };
};

export const fetchPendingConnections = () => ({
    type: types.FETCH_PROFILE_PENDING_CONNECTIONS
});
// END PENDING CONNECTION REQUEST

/**
 * BEGIN ACCEPT CONNECTION REQUEST
 **/
export const acceptConnectionRequest = (connectionRequestId, displayName, fetchStatus = true, callback) => ({
    type: types.ACCEPT_CONNECTION_REQUEST,
    connectionRequestId,
    displayName,
    fetchStatus,
    callback
});
// END ACCEPT CONNECTION REQUEST

/**
 * BEGIN DECLINE CONNECTION REQUEST
 **/
export const declineConnectionRequest = (connectionRequestId, displayName, callback) => ({
    type: types.DECLINE_CONNECTION_REQUEST,
    connectionRequestId,
    displayName,
    callback
});
// * END DECLINE CONNECTION REQUEST

/**
 * BEGIN DISCONNECT CONNECTION REQUEST
 **/
export const disconnectConnection = (connectionRequestId, displayName) => ({
    type: types.DISCONNECT_CONNECTION,
    connectionRequestId,
    displayName
});
// * END DISCONNECT CONNECTION REQUEST

export const cancelConnectionRequest = (connectionRequestId, displayName) => ({
    type: types.CANCEL_CONNECTION_REQUEST,
    connectionRequestId,
    displayName
});

/**
 * BEGIN BLOCK USER REQUEST
 **/
export const blockUserRequest = (displayName) => ({
    type: types.BLOCK_USER_REQUEST,
    displayName
});
// * END DISCONNECT CONNECTION REQUEST

/**
 * BEGIN BLOCK USER REQUEST
 **/
export const unBlockUserRequest = (displayName) => ({
    type: types.UNBLOCK_USER_REQUEST,
    displayName
});
// * END DISCONNECT CONNECTION REQUEST

/**
 * MODAL STATE
 */
export const showModal = (data) => ({
    type: types.SHOW_MODAL,
    data
});

export const hideModal = (data) => ({
    type: types.HIDE_MODAL,
    data
});

export const enableConfirmationButton = () => ({
    type: types.ENABLE_CONFIRMATION_BUTTON
});

export const disableConfirmationButton = () => ({
    type: types.DISABLE_CONFIRMATION_BUTTON
});

//END MODAL STATE

/**
 * USER PROFILE PERSONAL INFORMATION
 */
export const requestUserPersonalInfo = () => {
    return {
        type: types.REQUEST_USER_PERSONAL_INFO
    };
};

export const receiveUserPersonalInfo = (json) => {
    return {
        type: types.RECEIVE_USER_PERSONAL_INFO,
        json,
        receivedAt: Date.now()
    };
};

export const failedUserPersonalInfo = () => {
    return {
        type: types.FAILED_USER_PERSONAL_INFO,
        json: {},
        receivedAt: Date.now()
    };
};

export const resetUserPersonalInfo = () => {
    return { type: types.RESET_USER_PERSONAL_INFO };
};

export const fetchUserPersonalInfo = (displayName, options) => ({
    type: types.FETCH_USER_PERSONAL_INFO,
    displayName,
    includeBiometric: options ? options.includeBiometric : undefined,
    includeVO2Max: options ? options.includeVO2Max : undefined
});
/**
 * USER DAILY STEPS
 */

export const requestUserDailySteps = (displayName) => {
    return {
        type: types.REQUEST_USER_DAILY_STEPS,
        displayName
    };
};

export const receiveUserDailySteps = (data) => {
    return {
        type: types.RECEIVE_USER_DAILY_STEPS,
        data,
        receivedAt: Date.now()
    };
};

export const failedUserDailySteps = () => {
    return {
        type: types.FAILED_USER_DAILY_STEPS,
        data: [],
        receivedAt: Date.now()
    };
};

export const resetUserDailySteps = () => {
    return { type: types.RESET_USER_DAILY_STEPS };
};

export const fetchUserDailySteps = (displayName, startIndex) => ({
    type: types.FETCH_USER_DAILY_STEPS,
    displayName,
    startIndex
});

/**
 * STATISTICS
 */

export const requestUserStatistics = () => ({
    type: types.REQUEST_USER_STATISTICS
});

export const receiveUserStatistics = (json, displayName) => ({
    type: types.RECEIVE_USER_STATISTICS,
    displayName,
    json,
    receivedAt: Date.now()
});

export const resetUserStatistics = () => {
    return { type: types.RESET_USER_STATISTICS };
};

export const fetchUserStatistics = (displayName) => ({
    type: types.FETCH_USER_STATISTICS,
    displayName
});
//END STATISTICS

/**
 * FAVORITE ACTIVITIES
 */
export const requestFavoriteActivities = () => {
    return {
        type: types.REQUEST_FAVORITE_ACTIVITIES
    };
};

export const receiveFavoriteActivities = (json, displayName) => {
    return {
        type: types.RECEIVE_FAVORITE_ACTIVITIES,
        displayName,
        json,
        receivedAt: Date.now()
    };
};

export const resetFavoriteActivities = () => {
    return { type: types.RESET_FAVORITE_ACTIVITIES };
};

export const fetchFavoriteActivities = (displayName, limit) => ({
    type: types.FETCH_FAVORITE_ACTIVITIES,
    displayName,
    limit
});
//END FAVORITE ACTIVITIES

/**
 * WEIGHT
 */
export const onAddWeight = () => ({
    type: types.ADD_WEIGHT
});

export const addWeight = (url, weight, unit, date, callback) => ({
    type: types.ADD_WEIGHT_REQUEST,
    weight,
    unit,
    date,
    callback
});

export const onDeleteWeight = () => ({
    type: types.DELETE_WEIGHT
});

export const deleteWeight = (url, date, callback) => ({
    type: types.DELETE_WEIGHT_REQUEST,
    date,
    callback
});
// END WEIGHT

/**
 * GOALS
 */

export const requestGoals = () => ({
    type: types.REQUEST_GOALS
});

export const receiveGoals = (json, status, start, limit, sortOrder, replace) => ({
    type: types.RECEIVE_GOALS,
    goals: json,
    status,
    start,
    limit,
    sortOrder,
    receivedAt: Date.now(),
    replace
});

export const receiveAllGoals = (json, start, limit, sortOrder) => ({
    type: types.RECEIVE_ALL_GOALS,
    goals: json,
    start,
    limit,
    sortOrder,
    receivedAt: Date.now()
});

export const fetchGoals = (status, start, limit, sortOrder, replace) => ({
    type: types.FETCH_GOALS,
    status,
    start,
    limit,
    sortOrder,
    replace
});

export const fetchAllGoals = (callback = () => {}) => ({
    type: types.FETCH_ALL_GOALS,
    callback: callback
});

export const onDeleteGoal = (goalId) => ({
    type: types.DELETE_GOAL,
    goalId
});

export const deleteGoal = (goalId, callback) => ({
    type: types.DELETE_GOAL_REQUEST,
    goalId,
    callback
});

export const updateGoal = (goalId, data, callback) => ({
    type: types.UPDATE_GOAL,
    goalId,
    data,
    callback
});

export const onCreateGoal = () => ({
    type: types.CREATE_GOAL
});

export const createGoal = (data, callback) => ({
    type: types.CREATE_GOAL_REQUEST,
    data,
    callback
});
// END GOALS

/**
 * WORKOUT
 */

export const onScheduleWorkout = () => ({
    type: types.SCHEDULE_WORKOUT
});

export const scheduleWorkout = (workoutId, date, callback) => ({
    type: types.SCHEDULE_WORKOUT_REQUEST,
    workoutId,
    date,
    callback
});

export const rescheduleWorkout = (workout, workoutId, workoutScheduleId, date, callback) => ({
    type: types.RESCHEDULE_WORKOUT,
    workout,
    workoutId,
    workoutScheduleId,
    date,
    callback
});

export const onRemoveScheduledWorkout = () => ({
    type: types.REMOVE_SCHEDULED_WORKOUT
});

export const removeScheduledWorkout = (workoutScheduleId, callback) => ({
    type: types.REMOVE_SCHEDULED_WORKOUT_REQUEST,
    workoutScheduleId,
    callback
});

export const requestWorkoutSchedule = (workoutScheduleId) => ({
    type: types.REQUEST_WORKOUT_SCHEDULE,
    workoutScheduleId: workoutScheduleId
});

export const receiveWorkoutSchedule = (data, workoutScheduleId) => ({
    type: types.RECEIVE_WORKOUT_SCHEDULE,
    data,
    workoutScheduleId: workoutScheduleId,
    receivedAt: Date.now()
});

export const fetchWorkoutSchedule = (workoutScheduleId, callback, includeAudioNotes) => ({
    type: types.FETCH_WORKOUT_SCHEDULE,
    workoutScheduleId,
    callback,
    includeAudioNotes
});

export const requestWorkoutsExport = () => ({
    type: types.REQUEST_WORKOUTS_EXPORT
});

export const receiveWorkoutsExport = (data) => ({
    type: types.RECEIVE_WORKOUTS_EXPORT,
    data,
    receivedAt: Date.now()
});

export const fetchWorkoutsExport = (date, callback) => ({
    type: types.FETCH_WORKOUTS_EXPORT,
    date,
    callback
});

export const fetchfbtAdaptiveWorkout = (workoutUuid, callback) => ({
    type: types.FETCH_FBT_WORKOUT,
    workoutUuid,
    callback
});

// END WORKOUT

/**
 * PROFILE PAGE
 */
export const setProfilePageSelectedTab = (selectedTab) => {
    return {
        type: types.SELECT_PROFILE_PAGE_TAB,
        selectedTab
    };
};
export const profilePageSetReportDialog = ({ open, submitting, reviewStatus }) => {
    return {
        type: types.PROFILE_PAGE_REPORT_SET_REPORT_DIALOG,
        open,
        submitting,
        reviewStatus
    };
};
export const profilePageReportUserProfileImage = ({ displayName, flagReason, note }) => {
    return {
        type: types.PROFILE_PAGE_REPORT_USER_PROFILE_IMAGE,
        displayName,
        flagReason,
        note
    };
};

// UPCOMING EVENTS
export const requestUpcomingEvents = (displayName) => {
    return {
        type: types.REQUEST_UPCOMING_EVENTS,
        displayName
    };
};

export const receiveUpcomingEvents = (displayName, data) => {
    return {
        type: types.RECEIVE_UPCOMING_EVENTS,
        displayName,
        upcomingEvents: data,
        receivedAt: Date.now()
    };
};

export const resetUpcomingEvents = () => {
    return { type: types.RESET_UPCOMING_EVENTS };
};

export const fetchUpcomingEvents = ({ displayName, guid, startDate, limit = 5, callback }) => ({
    type: types.FETCH_UPCOMING_EVENTS,
    displayName,
    guid,
    startDate,
    limit,
    callback
});

/* These are used by calendar events */
export const requestUpcomingCalEvents = () => {
    return {
        type: types.REQUEST_UPCOMING_CAL_EVENTS
    };
};

export const receiveUpcomingCalEvents = (data) => {
    return {
        type: types.RECEIVE_UPCOMING_CAL_EVENTS,
        upcomingEvents: data,
        receivedAt: Date.now()
    };
};

export const fetchUpcomingCalEvents = ({ guid, startDate, limit = 25, numDaysForward = 365 }) => ({
    type: types.FETCH_UPCOMING_CAL_EVENTS,
    guid,
    startDate,
    limit,
    numDaysForward
});

export const resetUpcomingCalEvents = () => {
    return { type: types.RESET_UPCOMING_CAL_EVENTS };
};

// REPORTS
export const requestMonthlyReport = (displayName) => {
    return {
        type: types.REQUEST_MONTHLY_REPORT,
        displayName
    };
};

export const receiveMonthlyReport = (displayName, json) => {
    return {
        type: types.RECEIVE_MONTHLY_REPORT,
        displayName,
        monthlyReport: json.userMetrics,
        receivedAt: Date.now()
    };
};

export const resetMonthlyReport = () => {
    return { type: types.RESET_MONTHLY_REPORT };
};

export const fetchMonthlyReport = (displayName) => ({
    type: types.FETCH_MONTHLY_REPORT,
    displayName
});

// Steps Reports
export const requestStepsReport = (type, displayName) => {
    return {
        type: type,
        displayName
    };
};

export const receiveStepsReport = (type, displayName, json) => {
    return {
        type: type,
        displayName,
        stepsReport: json.allMetrics,
        receivedAt: Date.now()
    };
};

export const resetStepsReport = () => {
    return { type: types.RESET_STEPS_REPORT };
};

export const fetchStepsReport = (period, displayName, startDate, endDate, lifetimeSteps = false) => ({
    type: types.FETCH_STEPS_REPORT,
    period,
    displayName,
    startDate,
    endDate,
    lifetimeSteps
});

export const requesActivities365Report = (displayName) => {
    return {
        type: types.REQUEST_ACTIVITIES_365_REPORT,
        displayName
    };
};

export const receiveActivities365Report = (displayName, json) => {
    return {
        type: types.RECEIVE_ACTIVITIES_365_REPORT,
        displayName,
        activities365Report: json,
        receivedAt: Date.now()
    };
};

export const resetActivities365Report = () => {
    return { type: types.RESET_ACTIVITIES_365_REPORT };
};

export const fetchActivities365Report = (displayName) => ({
    type: types.FETCH_ACTIVITIES_365_REPORT,
    displayName
});

/**
 * ACTIVITIES
 */

export const requestActivities = (displayName) => {
    return {
        type: types.REQUEST_ACTIVITIES,
        displayName
    };
};

export const requestActivityHrTimeInZone = (activityId) => {
    return {
        type: types.REQUEST_ACTIVITY_HR_TIME_IN_ZONE,
        activityId
    };
};

export const receiveActivities = (data) => {
    return {
        type: types.RECEIVE_ACTIVITIES,
        data,
        receivedAt: Date.now()
    };
};

export const receiveActivityHrTimeInZone = (data) => {
    return {
        type: types.RECEIVE_ACTIVITY_HR_TIME_IN_ZONE,
        data,
        receivedAt: Date.now()
    };
};

export const resetActivities = () => {
    return { type: types.RESET_ACTIVITIES };
};

export const fetchActivities = (displayName, startIndex, limit) => ({
    type: types.FETCH_ACTIVITIES,
    displayName,
    startIndex,
    limit
});

export const fetchActivityHrTimeInZone = (activityId) => ({
    type: types.FETCH_ACTIVITY_HR_TIME_IN_ZONE,
    activityId
});

//END ACTIVITIES

/**
 * ACTIVITY POLYLINE
 */

export const requestActivityPolyline = (displayName) => {
    return {
        type: types.REQUEST_ACTIVITY_POLYLINE,
        displayName
    };
};

export const receiveActivityPolyline = (displayName, data, activityId) => {
    return {
        type: types.RECEIVE_ACTIVITY_POLYLINE,
        displayName,
        data,
        activityId,
        receivedAt: Date.now()
    };
};

export const resetActivityPolyline = () => {
    return { type: types.RESET_ACTIVITY_POLYLINE };
};

export const fetchActivityPolyline = (displayName, activityId) => ({
    type: types.FETCH_ACTIVITY_POLYLINE,
    displayName,
    activityId
});

export const fetchActivityPolylineForBaidu = (displayName, activityId, callback) => ({
    type: types.FETCH_ACTIVITY_POLYLINE_BAIDU,
    displayName,
    activityId,
    callback
});

/**
 * fetch activity polyline for Profile Page. this will convert to baidu data points when necessary in china mode
 * @param {string} displayName
 * @param {number} activityId
 * @param {boolean} [isChina]
 * @returns
 */
export const fetchActivityPolylineForProfile = (displayName, activityId, isChina = false) => ({
    type: isChina ? types.FETCH_ACTIVITY_POLYLINE_BAIDU : types.FETCH_ACTIVITY_POLYLINE,
    displayName,
    activityId
});
//END ACTIVITY POLYLINE

// GEAR
export const requestGear = (displayName) => {
    return {
        type: types.REQUEST_GEAR,
        displayName
    };
};

export const receiveGear = (displayName, json) => {
    return {
        type: types.RECEIVE_GEAR,
        displayName,
        gear: json,
        receivedAt: Date.now()
    };
};

export const resetGear = () => {
    return { type: types.RESET_GEAR };
};

export const fetchGear = (displayName) => ({
    type: types.FETCH_GEAR,
    displayName
});

export const resetProfilePage = () => ({
    type: types.RESET_PROFILE_PAGE_REQUEST
});

// USER PREFERENCE
export const requestUserPreference = (type) => {
    return {
        type,
        receivedAt: Date.now()
    };
};

export const receiveUserPreference = (type, json) => {
    return {
        type,
        preference: json,
        receivedAt: Date.now()
    };
};

// @deprecated - Use the saga based fetchUserPreference in reducers/preference/preference
export const fetchUserPreference = (key) => ({
    type: types.FETCH_USER_PREFERENCE_DEP,
    key
});

// @deprecated - Use the saga based saveUserPreference in reducers/preference/preference
export const setUserPreference = (key, value) => ({
    type: types.SET_USER_PREFERENCE_DEP,
    key,
    value
});

export const requestActivitiesBySearch = (type) => {
    return {
        type,
        receivedAt: Date.now()
    };
};

export const receiveActivitiesBySearch = (type, json, parentActivityType, favorite) => {
    return {
        type,
        activities: json,
        parentActivityType: parentActivityType,
        favorite: favorite,
        receivedAt: Date.now()
    };
};

export const receiveActivitiesBySearchError = (type, error) => {
    return {
        type,
        error: error,
        receivedAt: Date.now()
    };
};

/**
 *
 * @param parentActivityType = the parent type of activity that is being searched for
 * @param favorite = a boolean that should be set to true when searching for favorited activities (defaulted to false)
 * @param start = the index where the query starts/should continue for progressive loading
 * @param limit = the fetch limit for progressive loading (see diving)
 */
export const fetchActivitiesBySearch = ({ parentActivityType, favorite = false, start, limit }) => ({
    type: types.FETCH_ACTIVITIES_BY_SEARCH,
    parentActivityType,
    favorite,
    start,
    limit
});

export const receiveFavoriteActivity = (type, parentActivityType, activityDetails, favorite) => {
    return {
        type,
        parentActivityType: parentActivityType,
        activityDetails: activityDetails,
        favorite: favorite,
        receivedAt: Date.now()
    };
};

/**
 *
 * @param parentActivityType = the parent type of activity that is being favorited
 * @param activityDetails = details of the activity
 * @param favorite = whether or not you are favoriting or un-favoriting this activity
 */
export const favoriteActivity = (parentActivityType, activityDetails, favorite) => ({
    type: types.FAVORITE_ACTIVITY,
    parentActivityType,
    activityDetails,
    favorite
});

export const receiveDeleteActivityBySearch = (type, parentActivityType, activityDetails) => {
    return {
        type,
        parentActivityType: parentActivityType,
        activityDetails: activityDetails,
        receivedAt: Date.now()
    };
};

/**
 *
 * @param parentActivityType = the parent type of activity that is being deleted
 * @param activityDetails = details of the activity
 */
export const deleteActivityBySearch = (parentActivityType, activityDetails) => ({
    type: types.DELETE_ACTIVITY_BY_SEARCH,
    parentActivityType,
    activityDetails
});

export const resetActivitiesBySearch = () => {
    return { type: types.RESET_ACTIVITIES_BY_SEARCH };
};

export const setSelectedDive = (activityId) => ({
    type: types.SET_SELECTED_DIVE,
    selectedDive: activityId
});

export const setGolfStatsPageState = (pageState) => ({
    type: types.SET_GOLF_STATS_PAGE_STATE,
    pageState
});

export const setApproachGolfStatsFilter = (clubIdsSelected, areClubIdsSaved) => ({
    type: types.SET_APPROACH_GOLF_STATS_FILTER,
    clubIdsSelected: clubIdsSelected,
    areClubIdsSaved: areClubIdsSaved
});

export const setDriveGolfStatsFilter = (clubIdsSelected, areClubIdsSaved) => ({
    type: types.SET_DRIVE_GOLF_STATS_FILTER,
    clubIdsSelected: clubIdsSelected,
    areClubIdsSaved: areClubIdsSaved
});

export const setChipGolfStatsFilter = (clubIdsSelected, areClubIdsSaved) => ({
    type: types.SET_CHIP_GOLF_STATS_FILTER,
    clubIdsSelected: clubIdsSelected,
    areClubIdsSaved: areClubIdsSaved
});

// System preference
export const requestSystemPreference = (type) => {
    return {
        type,
        receivedAt: Date.now()
    };
};

export const receiveSystemPreference = (type, key, json) => {
    return {
        type,
        key,
        preference: json,
        receivedAt: Date.now()
    };
};

export const fetchSystemPreference = (key) => ({
    type: types.FETCH_SYSTEM_PREFERENCE,
    key
});

export function fetchSystemPreferenceWithOptions(preferenceKey, nextActions, truthTestFunc) {
    return {
        type: types.FETCH_SYSTEM_PREFERENCE_WITH_OPTIONS,
        preferenceKey: preferenceKey,
        nextActions: nextActions,
        truthTestFunc: truthTestFunc
    };
}

export function fetchPrimaryTrainingDevice(userId) {
    return {
        type: types.FETCH_PRIMARY_TRAINING_DEVICE,
        userId
    };
}

export function updatePrimaryTrainingDevice(userId, deviceId, callback) {
    return {
        type: types.UPDATE_PRIMARY_TRAINING_DEVICE,
        userId,
        deviceId,
        callback
    };
}

export function updatePrimaryActivityTracker(userId, deviceId, callback) {
    return {
        type: types.UPDATE_PRIMARY_ACTIVITY_TRACKER,
        userId,
        deviceId,
        callback
    };
}

export function removeDevice(deviceId, callback) {
    return {
        type: types.REMOVE_DEVICE,
        deviceId,
        callback
    };
}
